import React from "react";
export { default as AppRoutes } from "./AppRoutes";

export const Dashboard = React.lazy(() => import("../feature/Dashboard"));
export const AdSpot = React.lazy(() => import("../feature/AdSpot"));
export const CarrierWalkReport = React.lazy(() =>
  import("../feature/CarrierWalk/CarrierWalkReport")
);
export const FileUploaderContainer = React.lazy(() =>
  import("../feature/FileUpload/FileUploadContainer")
);
export const FSAMapContainer = React.lazy(() =>
  import("../feature/FSAMap/FSAMapContainer")
);
export const MapRadiusContainer = React.lazy(() =>
  import("../feature/MapRadius/MapRadiusContainer")
);
export const MergeFilesContainer = React.lazy(() =>
  import("../feature/MergeFiles/MergeFilesContainer")
);
export const ExtractAudienceContainer = React.lazy(() =>
  import("../feature/ExtractAudience/ExtractAudienceContainer")
);
export const AddNewFile = React.lazy(() =>
  import("../feature/AddNewFile/AddNewFile")
);
export const ExtracedAudiencesListView = React.lazy(() =>
  import("../feature/ExtractedAudiences")
);
export const CarrierWalkListView = React.lazy(() =>
  import("../feature/CarrierWalk/CarrierWalkListView")
);
export const InsightsReportFileSelection = React.lazy(() =>
  import("../feature/InsightsReportFileSelection")
);
export const FilesListView = React.lazy(() =>
  import("../feature/FilesListView")
);
export const ReportsListView = React.lazy(() =>
  import("../feature/ReportsListView")
);
export const ProjectsListView = React.lazy(() =>
  import("../feature/ProjectsListView")
);
export const NotFound = React.lazy(() => import("../feature/NotFound"));
export const BatchFileUploader = React.lazy(() =>
  import("../feature/BatchFileUploader")
);
